import { useCallback, useRef } from "react";

import { Box, Stack } from "@similarweb/ui-components/foundations";

import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { useSubtitleFilters } from "app/custom-hooks/useSubtitleFilters";
import { useCategoriesComparison } from "app/pages/industry-analysis/categories-context";
import { PdfExportService } from "app/services/PdfExportService";
import { useTranslation } from "pro-features/components/WithTranslation";

import { useDemographicsGenderDistributionComparisonData } from "../../hooks/useDemographicsGenderDistributionComparisonData";

import { GenderDistributionComparisonShareBar } from "./GenderDistributionComparisonShareBar";

export const IndustryAnalysisDemographicsGenderDistributionComparison = () => {
    const t = useTranslation();
    const subtitleFilters = useSubtitleFilters("date");
    const { categories } = useCategoriesComparison();
    const chartRef = useRef(null);

    const { data, isLoading, isError } = useDemographicsGenderDistributionComparisonData(categories);

    const handleExportChartPng = useCallback(() => {
        if (chartRef.current) {
            const styleHTML = PdfExportService.getStylesheetsForPng();

            const offSetX = 0;
            const offSetY = 100;
            return PdfExportService.downloadHtmlPngFedService(
                styleHTML + chartRef.current.outerHTML,
                "Gender Distribution",
                chartRef.current.offsetWidth + offSetX,
                chartRef.current.offsetHeight + offSetY,
            );
        }
    }, []);

    return (
        <Box ref={chartRef}>
            <WidgetContainer
                withBorder
                minWidth="100%"
                loaderHeight={115}
                loaderWidth="100%"
                isLoading={isLoading}
                noData={isError ? !isLoading : null}
                subtitleFilters={subtitleFilters}
                title={t("category.demographics.gender.chart.title")}
                downloadProps={{ PNG: true }}
                onDownloadClick={handleExportChartPng}
                automationId="industry-analysis-demographics-comparison-gender-distribution"
            >
                <Stack
                    gap="24px"
                    padding="24px"
                >
                    {data
                        ? Object.entries(data).map(([key, value]) => (
                              <GenderDistributionComparisonShareBar
                                  key={key}
                                  data={value}
                                  category={categories.find(({ category }) => category.id === key)}
                              />
                          ))
                        : null}
                </Stack>
            </WidgetContainer>
        </Box>
    );
};
